module.exports = function () {
    $('.hero-carousel-module').each(function () {
        var $heroCarouselModule = $(this);

        $('.hero-carousel-module__video-wrapper').each(function () {
            $videoWrapper = $(this);
            $videoPlayer = $videoWrapper.find('wistia-player');

            if ($videoPlayer.length) {
                var videoAspectRatio = $videoPlayer.attr('aspect');
                var $parentSlide = $videoPlayer.closest('.hero-carousel-module__slide');
                var containerHeight = $parentSlide.outerHeight();
                var containerWidth = $parentSlide.outerWidth();
                var containerAspectRatio = containerWidth / containerHeight;

                if (containerAspectRatio < videoAspectRatio) {
                    var updatedVideoWidth = Math.ceil(containerHeight * videoAspectRatio);
                    $videoPlayer.css('width', updatedVideoWidth + 'px').css('height', containerHeight + 'px');
                }
                else if (containerAspectRatio > videoAspectRatio) {
                    var updatedVideoHeight = Math.ceil(containerWidth * (1 / videoAspectRatio));
                    $videoPlayer.css('width', containerWidth + 'px').css('height', updatedVideoHeight + 'px');
                }
            }
        });
    });
};